import { Row } from "antd";
import { withTranslation } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import {
  HeaderSection,
  LogoContainer,
  HorizontalBar,
} from "./styles";

const Header = () => {
  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <SvgIcon src="logo.svg" width="300px" height="105px" />
          </LogoContainer>
          <HorizontalBar />
        </Row>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
